import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem;
`;

export const StyledGhostImage = styled.img`
  width: 80px;
  height: auto;
  margin-bottom: 1rem;
`;

export const StyledTitle = styled.h3`
  ${pickThemeFontStyles('16', '24', 'NORMAL')};
  color: ${COLORS.BLACK};
  margin: 0 0 0.5rem 0;
  text-align: center;
`;

export const StyledMessage = styled.p`
  ${pickThemeFontStyles('12', '18', 'NORMAL')};
  color: ${COLORS.GRAY_SECONDARY};
  margin: 0 0 1.5rem 0;
  text-align: center;
`;

export const StyledButton = styled.button`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  background-color: ${COLORS.YELLOW_PRIMARY};
  color: ${COLORS.BLACK};
  border: none;
  border-radius: 0.5rem;
  padding: 0.75rem 2rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${COLORS.YELLOW_PRIMARY};
  }

  &:active {
    background-color: ${COLORS.YELLOW};
  }
`;
